export default __webpack_public_path__ + "static/media/3rd-party-home-Background2.beec958f.svg";